import React from 'react';
import buildVersion from '../../version';

class BuildVersion extends React.Component {
  render() {
    return (<span className="SportClientBuildVersion">{buildVersion}</span>);
  }
}

export default BuildVersion;
